export default "__VITE_ASSET__c5c92eed__"